export enum inputTypes {
  INTEGER_RANGE = 'integer_range',
  INTEGER = 'integer',
  STRING = 'string',
  SECRET = 'secret',
  ENUM = 'enum',
  NUMBER = 'number',
  DATETIME = 'datetime',
  TIME = 'time',
  DURATION = 'duration',
  DOUBLE = 'double',
  BLOCK_ARRAY = 'block_array',
  TEXT = 'text'
}
